import React, { useState, useEffect } from 'react';
import './CreatePlayer.css';
import { Link, useLocation } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import Select from 'react-select';
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
const CreatePlayer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('auth-token');
  const { selectedCenter, userData } = useUser();
  const loginId = userData.userId
  const searchParams = new URLSearchParams(location.search);
  const academyId = location.state?.academyId || searchParams.get('academyId');
  const playerId = location.state?.playerId || searchParams.get('playerId');
  const userId = location.state?.userId || searchParams.get('userId');
  const guardianId = location.state?.guardianId || searchParams.get('guardianId');
  const [formData, setFormData] = useState({
    name: '',
    mobileNumber: '',
    gender: '',
    playerCategory: '',
    playerLevel: '',
    playerProfile: '',
    dob: '',
    parentInfo: [
      { parentName: '', parentMobileNumber: '', parentRelation: '' },
      { parentName: '', parentMobileNumber: '', parentRelation: '' },
    ],
    hideProfileStats: false,
  });
  const [dropdownData, setDropdownData] = useState({
    genderTypes: [],
    playerCategoryTypes: [],
    playerLevelTypes: []
  });

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_NEW_PLAYER}?academyId=${selectedCenter}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
        const result = await response.json();
        if (result.success) {
          setDropdownData({
            genderTypes: result.data.genderTypes,
            playerCategoryTypes: result.data.playerCategoryTypes,
            playerLevelTypes: result.data.playerLevelTypes
          });
        }
      } catch (error) {
      }
    };

    if (selectedCenter) {
      fetchDropdownData();
    }
  }, [selectedCenter]);

  useEffect(() => {
    if (!userId) return;
    const fetchPlayerData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_NEW_PLAYER}?academyId=${selectedCenter}&parentUser1=${userId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const result = await response.json();
        if (result.success) {
          const playerData = result.data.playerForm;

          const formattedDOB = playerData.dateOfBirth
            ? playerData.dateOfBirth.split("T")[0]
            : '';
          const formattedJoiningDate = playerData.joiningDate
            ? playerData.joiningDate.split('T')[0]
            : null;
          setFormData({
            name: playerData.name || '',
            mobileNumber: playerData.mobileNumber ? playerData.mobileNumber.replace(/^\+91/, '') : '',
            gender: playerData.genderType || '',
            playerCategory: playerData.playerCategoryType || '',
            playerLevel: playerData.playerLevelType || 'NA',
            playerProfile: playerData.playerProfile || 'NA',
            dob: formattedDOB,
            joiningDate: formattedJoiningDate,
            parentInfo: playerData.playerParentForms
              ? playerData.playerParentForms.map(parent => ({
                parentId: userId || null,
                parentName: parent.name || '',
                parentMobileNumber: parent.mobileNumber?.replace(/^\+91/, '') || '',
                parentRelation: parent.relation || '',
              }))
              : [{ parentName: '', parentMobileNumber: '', parentRelation: '' }],
            hideProfileStats: playerData.isStatsHidden || false,
          });
        }
      } catch (error) {

      }
    };

    fetchPlayerData();
  }, [userId]);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name && name.startsWith('parentInfo')) {
      const matches = name.match(/parentInfo\[(\d+)\]\.(\w+)/);
      if (matches) {
        const index = parseInt(matches[1]);
        const field = matches[2];
        const updatedParentInfo = [...formData.parentInfo];
        updatedParentInfo[index][field] = value;
        setFormData({ ...formData, parentInfo: updatedParentInfo });
        return;
      }
    }

    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();


const isPlayerMobileValid = formData.mobileNumber && /^[0-9]{10}$/.test(formData.mobileNumber);

const hasValidParentMobile = formData.parentInfo.some(
  (parent) => /^[0-9]{10}$/.test(parent.parentMobileNumber)
);

if (!isPlayerMobileValid && !hasValidParentMobile) {
  Swal.fire({
    icon: 'error',
    title: 'Mobile Number Required',
    text: 'Please enter either a valid 10-digit player mobile number or a parent mobile number.',
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
  });
  return;
}

    const playerParentForms = formData.parentInfo
      .filter(parent =>

        parent.parentName ||
        parent.parentMobileNumber ||
        parent.parentRelation
      )
      .map(parent => ({
        id: parent.parentId || null,
        name: parent.parentName.trim(),
        mobileNumber: parent.parentMobileNumber ? `+91${parent.parentMobileNumber}` : null,
        relation: parent.parentRelation.trim()
      }));
    const joiningDate = playerId
      ? formData.joiningDate
      : new Date().toISOString().split('T')[0];

    const requestBody = {
      academyId: Number(selectedCenter),
      id: null || playerId,
      mobileNumber: formData.mobileNumber ? `+91${formData.mobileNumber}` : null,
      name: formData.name.trim(),
      playerCategoryType: formData.playerCategory.toUpperCase() || null,
      playerLevelType: formData.playerLevel.toUpperCase() ||null,
      playerProfile: formData.playerProfile.toUpperCase() || null ,
      dateOfBirth: formData.dob || null,
      joiningDate: joiningDate ,
      genderType: formData.gender.toUpperCase() || null ,
      playerParentForms: playerParentForms,
    };


    try {
      const response = await fetch(process.env.REACT_APP_API_NEW_PLAYER, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      const result = await response.json();

      if (response.ok) {
        const message = playerId ? "Player updated successfully!" : "Player created successfully!";

        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
        navigate(-1);
      } else {

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: result.errorMessage || result.message || "Unknown error",
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
      }
    } catch (error) {

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: "An error occurred while creating the player.",
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  const genderOptions = dropdownData.genderTypes.map(gender => ({
    value: gender,
    label: gender.charAt(0) + gender.slice(1).toLowerCase()
  }));

  const playerCategoryOptions = dropdownData.playerCategoryTypes.map(category => ({
    value: category,
    label: category
  }));

  const playerLevelOptions = dropdownData.playerLevelTypes.map(level => ({
    value: level,
    label: level.split('_').map(word => word.charAt(0) + word.slice(1).toLowerCase()).join(' ')
  }));

  const playerProfileOptions = dropdownData.playerLevelTypes.map(level => ({
    value: level,
    label: level === 'NA' ? 'N/A' :
      level.split('_').map(word => word.charAt(0) + word.slice(1).toLowerCase()).join(' ')
  }));
  const [dropdownOpen, setDropdownOpen] = useState(null);


  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdown = document.querySelector('.custom-dropdown-player');
      if (dropdown && !dropdown.contains(event.target) && !event.target.closest('.dots-btn-player')) {
        setDropdownOpen(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const { dob, playerCategory } = formData;
    const categories = dropdownData.playerCategoryTypes; 
    if (!dob || categories.length === 0) return;
    const today = new Date();
    const birth = new Date(dob);
    let age = today.getFullYear() - birth.getFullYear();
    const mDiff = today.getMonth() - birth.getMonth();
    if (mDiff < 0 || (mDiff === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    const desired = age + 1; 
  
    let autoCat;
    if (desired > 17 && categories.includes('OPEN')) {
      autoCat = 'OPEN';
    } else {
      const nums = categories
        .filter(cat => /^U\d+$/.test(cat))
        .map(cat => parseInt(cat.slice(1), 10));
  
      const ge = nums.filter(n => n >= desired);
      const pickNum = ge.length ? Math.min(...ge) : Math.max(...nums);
      autoCat = `U${pickNum}`;
    }
  
    if (autoCat !== playerCategory) {
      setFormData(prev => ({ ...prev, playerCategory: autoCat }));
    }
  }, [formData.dob, formData.playerCategory, dropdownData.playerCategoryTypes]);

  return (
    <div className="enrollment-container">
      <div className="breadcrumb">
        <Link to="/createNewPlayer" className="breadcrumb-link">Search User</Link> &gt; New Player
      </div>
      <form onSubmit={handleSubmit} className="walkin-enquiry-form">

        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <input
            type="text"
            id="name"
            name="name"
            className={`walkin-form ${formData.name ? 'has-value' : ''}`}
            value={formData.name}
            onChange={handleChange}
            required

          />
          <label htmlFor="name">Player Name</label>
        </div>


        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <input
            type="number"
            id="mobileNumber"
            name="mobileNumber"
            className={`walkin-form ${formData.mobileNumber ? 'has-value' : ''}`}
            value={formData.mobileNumber}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                handleChange(e);
              }
            }}
            maxLength={10}
            placeholder="Enter Mobile Number"
          />
          {formData.mobileNumber && (
            <label htmlFor="mobileNumber">Mobile Number</label>
          )}
        </div>



        <div className="floating-select-form" style={{ width: '98%' }}>
          <Select
            id="gender"
            name="gender"
            className={`walkin-form-dropdown ${formData.gender ? 'has-value' : ''}`}
            classNamePrefix="walkin-select"
            options={genderOptions}
            value={genderOptions.find(option => option.value === formData.gender)}
            onChange={selected => setFormData({ ...formData, gender: selected?.value || '' })}
            placeholder="Select Gender"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              control: (base, { isDisabled }) => ({
                ...base,
                backgroundColor: '#fff',    
                opacity: 1,   
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                borderColor: base.isFocused ? base.borderColor : '#ccc',
              }),
              singleValue: (base) => ({
                ...base,
                color: '#000',         
              }),
              placeholder: (base) => ({
                ...base,
                color: '#888',          
              }),
              dropdownIndicator: (base, { isDisabled }) => ({
                ...base,
                color: isDisabled ? '#000' : base.color, 
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: '#ccc',
              }),
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
          />
          {formData.gender && (
            <label htmlFor="gender">Gender</label>
          )}
        </div>


        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <Select
            id="playerCategory"
            name="playerCategory"
            className={`walkin-form-dropdown ${formData.playerCategory ? 'has-value' : ''}`}
            classNamePrefix="walkin-select"
            options={playerCategoryOptions}
            value={playerCategoryOptions.find(option => option.value === formData.playerCategory)}
            onChange={selected => setFormData({ ...formData, playerCategory: selected?.value || '' })}
            placeholder="Select Category"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              control: (base, { isDisabled }) => ({
                ...base,
                backgroundColor: '#fff',    
                opacity: 1,   
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                borderColor: base.isFocused ? base.borderColor : '#ccc',
              }),
              singleValue: (base) => ({
                ...base,
                color: '#000',         
              }),
              placeholder: (base) => ({
                ...base,
                color: '#888',          
              }),
              dropdownIndicator: (base, { isDisabled }) => ({
                ...base,
                color: isDisabled ? '#000' : base.color, 
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: '#ccc',
              }),
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
          />
          {formData.playerCategory && (
            <label htmlFor="playerCategory">Player Category</label>
          )}
        </div>


        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <Select
            id="playerLevel"
            name="playerLevel"
            className={`walkin-form-dropdown ${formData.playerLevel ? 'has-value' : ''}`}
            classNamePrefix="walkin-select"
            options={playerLevelOptions}
            value={playerLevelOptions.find(option => option.value === formData.playerLevel)}
            onChange={selected => setFormData({ ...formData, playerLevel: selected?.value || '' })}
            placeholder="Select Level"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              control: (base, { isDisabled }) => ({
                ...base,
                backgroundColor: '#fff',    
                opacity: 1,   
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                borderColor: base.isFocused ? base.borderColor : '#ccc',
              }),
              singleValue: (base) => ({
                ...base,
                color: '#000',         
              }),
              placeholder: (base) => ({
                ...base,
                color: '#888',          
              }),
              dropdownIndicator: (base, { isDisabled }) => ({
                ...base,
                color: isDisabled ? '#000' : base.color, 
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: '#ccc',
              }),
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
          />
          {formData.playerLevel && (
            <label htmlFor="playerLevel">Player Level</label>
          )}
        </div>

        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <Select
            id="playerProfile"
            name="playerProfile"
            className={`walkin-form-dropdown ${formData.playerProfile ? 'has-value' : ''}`}
            classNamePrefix="walkin-select"
            options={playerProfileOptions}
            value={playerProfileOptions.find(option => option.value === formData.playerProfile)}
            onChange={selected => setFormData({ ...formData, playerProfile: selected?.value || '' })}
            placeholder="Select Profile"
    
            isClearable
            menuPortalTarget={document.body}
            styles={{
              control: (base, { isDisabled }) => ({
                ...base,
                backgroundColor: '#fff',    
                opacity: 1,   
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                borderColor: base.isFocused ? base.borderColor : '#ccc',
              }),
              singleValue: (base) => ({
                ...base,
                color: '#000',         
              }),
              placeholder: (base) => ({
                ...base,
                color: '#888',          
              }),
              dropdownIndicator: (base, { isDisabled }) => ({
                ...base,
                color: isDisabled ? '#000' : base.color, 
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: '#ccc',
              }),
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
        
          />
          {formData.playerProfile && (
            <label htmlFor="playerProfile">Player Profile</label>
          )}
        </div>

        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <input
            type="date"
            id="dob"
            name="dob"
            className={'walkin-form has-value'}
            value={formData.dob}
            onChange={handleChange}

            onClick={e => e.target.showPicker()}
          />

          <label htmlFor="dob">Date of Birth</label>

        </div>

        <div className="input-container-hide-profile-stats">
          <input
            type="checkbox"
            id="hideProfileStats"
            name="hideProfileStats"
            checked={formData.hideProfileStats}
            onChange={handleChange}
            className="checkbox-field"

          />
          <label htmlFor="hideProfileStats" className="checkbox-label">Hide Profile Stats</label>
        </div>

        <div>
          <h3 className="parent-info-title">Parent Information</h3>
          <table className="parent-info-table">
            <thead>
              <tr>
                <th>Parent Name</th>
                <th>Parent Mobile Number</th>
                <th>Relation</th>
              </tr>
            </thead>
            <tbody>
              {formData.parentInfo.map((parent, index) => (
                <tr key={index}>
                  <td>
                    <input
                      type="text"
                      name={`parentInfo[${index}].parentName`}
                      value={parent.parentName}
                      onChange={handleChange}
                      className="input-field"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name={`parentInfo[${index}].parentMobileNumber`}
                      value={parent.parentMobileNumber}
                      onChange={(e) => {
                        const numericValue = e.target.value.replace(/\D/g, '');
                        const updatedParentInfo = [...formData.parentInfo];
                        updatedParentInfo[index].parentMobileNumber = numericValue;
                        setFormData({ ...formData, parentInfo: updatedParentInfo });
                      }}
                      className="input-field"
                      maxLength={10}
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      name={`parentInfo[${index}].parentRelation`}
                      value={parent.parentRelation}
                      onChange={handleChange}
                      className="input-field"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <button type="submit" className="submit-button">Submit</button>



      </form>
    </div>
  );
};

export default CreatePlayer;